import { render } from "./ShowForm.vue?vue&type=template&id=c9bf53d0&scoped=true"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"

import "./ShowForm.vue?vue&type=style&index=0&id=c9bf53d0&lang=css"
import "./ShowForm.vue?vue&type=style&index=1&id=c9bf53d0&scoped=true&lang=css"
import "./ShowForm.vue?vue&type=style&index=2&id=c9bf53d0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bf53d0"]])

export default __exports__